
<div class="table-container">
  <table class="table-data table-view-data" [ngClass]="{
      'table_borders': showBorders
    }">
    <thead >
    <tr #headerRow>
      @if(showCheckBox){
        <th class="cb_th select-all-cb">
          <input type="checkbox" id="selected_all" [checked]="isAllRecordsOfCurrentPageSelected()"
                 (change)="toggleAllRecordsOfCurrentPageSelections($event.target.checked)" [disabled]="readOnlyMode"/>
        </th>
      }
      <th class="sl_no_th" *ngIf="showSerialNumber"><span>Sl No</span></th>
      
      <th *ngFor="let column of tableMeta.columns" [ngStyle]="column?.thStyleConfig" >{{ column.displayName }}</th>
      
      <th class="sticky-actions actions_td" *ngIf="hasVisibleActions()"></th>

      <th class="actions_th" *ngIf="!readOnlyMode && (deleteAllowed || editAllowed)"><span></span></th>

    </tr>
    </thead>
      <tbody [class.no-hover]="!data?.length">
        @if (data?.length === 0) {
          <tr>
            <td [attr.colspan]="totalColspan">
              <app-no-data [msg]="noDataFoundMsg" [path]="noDataIconPath"></app-no-data>
            </td>
          </tr>
        } @else {

          <tr *ngFor="let result of data; let i = index" [ngClass]="isSelected(result) ? 'selected_row' : ''">
            
            @if(showCheckBox){
              <td class="cb_td row-select-cb">
                <input type="checkbox" (change)="toggleSelection(result)" [checked]="isSelected(result)" [disabled]="readOnlyMode"/>
              </td>
            }

            <td class="sl_no_td" *ngIf="showSerialNumber"><span> {{ i + 1 }} </span></td>
            
            <td *ngFor="let column of tableMeta.columns" [ngClass]="{ primary_column: column.fieldName === 'name' }">
              <app-tos-table-td
                [value]="CommonUtils.getNestedValue(result, column.fieldName)"
                [rowData]="result"
                [column]="column"
                (inlineAction)="handleInlineAction($event, i)"
              ></app-tos-table-td>
            </td>

            <td class="sticky-actions actions_td" *ngIf="hasVisibleActions()">
              <div class="action_buttons_wrapper">
                @for (column of tableMeta.actions; track $index) {
                  @if (!(readOnlyMode && column?.styleConfig?.actionConfig?.writeOpertion)) {
                    <app-tos-table-td
                      [value]="CommonUtils.getNestedValue(result, column.fieldName)"
                      [rowData]="result"
                      [column]="column"
                      (inlineAction)="handleInlineAction($event, i)"
                    ></app-tos-table-td>
                  }
              }
              </div>
            </td>

            <td class="actions_td" *ngIf="!readOnlyMode && (deleteAllowed || editAllowed)">
              <div class="action_buttons_wrapper">
                <div *ngIf="editAllowed" class="edit_icon">
                    <app-svg-icon class="edit-icon"
                                [path]="'assets/icons/pencil_icon.svg'"
                                (click)="editRecord(i, result)"></app-svg-icon>
                </div>
                <div *ngIf="deleteAllowed" class="delete_icon">
                  <app-svg-icon class="delete-icon"
                                [path]="'assets/icons/delete_icon.svg'"
                                (click)="removeElement(i,result)"></app-svg-icon>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
  </table>
</div>

